import { useTheme } from "@mui/material";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import React, { FunctionComponent } from "react";
import { MessageGroupTitleContainer, useMessageGroupStyles } from "src/Chat/component/styles";
import { MessageGroup } from "../api";
import Message from "./Message";
import { getLatestReplyFromMessage } from "./MSTeamsStore";

interface MessageGroupProps {
	/** messsage group */
	group: MessageGroup;
}

const MessageGroup: FunctionComponent<MessageGroupProps> = (({ group }) => {
	const {
		container,
		divider,
		messages,
	} = useMessageGroupStyles(useTheme());

	return (
		<Grid
			container
			direction="column"
			item
			sx={container}
		>
			<Divider sx={divider} />
			<MessageGroupTitleContainer>{group.groupTitle}</MessageGroupTitleContainer>
			<Grid
				container
				direction="column"
				item
				sx={messages}
			>
				{group.messages.map((message, i) => {
					const reply = getLatestReplyFromMessage(message);
					return (
						<div key={message.id}>
							<Message message={message} />
							{reply && (
								<Message
									isReply
									message={reply}
								/>
							)}
						</div>
					);
				})}
			</Grid>
		</Grid>
	);
});

export default MessageGroup;